import { render, staticRenderFns } from "./HTBereich.vue?vue&type=template&id=641a9d0e&scoped=true&"
import script from "./HTBereich.vue?vue&type=script&lang=js&"
export * from "./HTBereich.vue?vue&type=script&lang=js&"
import style0 from "./HTBereich.vue?vue&type=style&index=0&id=641a9d0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "641a9d0e",
  null
  
)

export default component.exports